let xsCol: string = "xsCol ";
let smallCol: string = "smallCol ";
let midCol: string = "midCol ";
let largeCol: string = "largeCol ";
let extraLargeCol: string = "extraLargeCol ";

let propertyEmpty = {
  labelHeader: "empty",
  objectKey: "",
  order: "",
  size: "xsColButton",
};

let columnaNotaStyle = {
  "min-width": "156px",
  "max-width": "156px",
  width: "156px",
};

export const TableConstants = {
  allShowed: {
    create: true,
    delete: true,
    arrowUpDown: true,
    orderColumns: true,
    label: true,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  notShowedFiltersButton: {
    create: true,
    delete: true,
    arrowUpDown: true,
    orderColumns: true,
    label: true,
    filtersButton: false,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  NotShowArrowUpDown: {
    arrowUpDown: false,
    create: true,
    delete: true,
    orderColumns: true,
    label: false,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  NotShowArrowUpDownAndShowDownloadReport: {
    arrowUpDown: false,
    create: true,
    delete: true,
    orderColumns: true,
    label: false,
    filtersButton: true,
    downloadReport: true,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  NotShowArrowUpDownAndShowLabel: {
    arrowUpDown: false,
    create: true,
    delete: true,
    orderColumns: true,
    label: true,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  NotShowArrowUpDownNotShowFiltersAndShowLabel: {
    arrowUpDown: false,
    create: true,
    delete: true,
    orderColumns: true,
    label: true,
    filtersButton: false,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  NotShowCreateDeleteArrowUpDownAndShowCheckbox: {
    create: false,
    delete: false,
    arrowUpDown: false,
    orderColumns: true,
    label: false,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  NotShowCreateDeleteAndArrowUpDown: {
    create: false,
    delete: false,
    arrowUpDown: false,
    orderColumns: true,
    label: false,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: false,
  },

  NotShowCreateDeleteAndArrowUpDownAndHideEditButton: {
    create: false,
    delete: false,
    arrowUpDown: false,
    orderColumns: true,
    label: false,
    hideEditButton: true,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: true,
    showCheckbox: false,
  },

  NotShowCreateDeleteAndArrowUpDownFiltersButtonAndShowLabel: {
    create: false,
    delete: false,
    arrowUpDown: false,
    orderColumns: true,
    label: true,
    hideEditButton: false,
    filtersButton: false,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: false,
  },

  NotShowCreateDeleteAndArrowUpDownAndShowLabel: {
    create: false,
    delete: false,
    arrowUpDown: false,
    orderColumns: true,
    label: true,
    hideEditButton: false,
    filtersButton: false,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: false,
  },

  NotShowDeleteAndArrowUpDown: {
    create: true,
    delete: false,
    arrowUpDown: false,
    orderColumns: true,
    label: false,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: false,
  },

  NotShowOrderColumns: {
    arrowUpDown: true,
    create: true,
    delete: true,
    orderColumns: false,
    label: false,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  NotShowOrderColumnsAndShowLabel: {
    arrowUpDown: true,
    create: true,
    delete: true,
    orderColumns: false,
    label: true,
    hideEditButton: false,
    filtersButton: false,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: true,
  },

  NotShowCreateDeleteArrowUpDownAndOrderColumns: {
    arrowUpDown: false,
    create: false,
    delete: false,
    orderColumns: false,
    label: false,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: false,
  },

  NotShowCreateDeleteAndArrowUpDownEditButtoAndShowLabel: {
    create: false,
    delete: false,
    arrowUpDown: false,
    orderColumns: true,
    hideEditButton: true,
    filtersButton: false,
    label: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: false,
  },

  concessionaire: [
    {
      labelHeader: "Id",
      objectKey: "coId",
      order: "id",
      size: midCol,
    },
    {
      labelHeader: "Nombre",
      objectKey: "coNombre",
      order: "nombre",
      size: extraLargeCol,
    },
    {
      labelHeader: "Activo",
      objectKey: "coActivo",
      order: "coActivo",
      size: smallCol,
    },
    {
      labelHeader: "Región",
      objectKey: "coRegion",
      order: "coRegion",
      size: midCol,
    },
  ],

  maintenanceUser: [
    {
      labelHeader: "Id",
      objectKey: "usId",
      order: "usId",
      xsColButton: true,
      size: smallCol,
    },
    {
      labelHeader: "Nombre",
      objectKey: "usNombre",
      order: "usNombre",
      size: midCol,
    },
    {
      labelHeader: "Apellido 1",
      objectKey: "usApellido1",
      order: "usApellido1",
      size: midCol,
    },
    {
      labelHeader: "Apellido 2",
      objectKey: "usApellido2",
      order: "usApellido2",
      size: midCol,
    },
    {
      labelHeader: "Email",
      objectKey: "usEmail",
      order: "usEmail",
      size: midCol,
    },
    {
      labelHeader: "Perfil",
      objectKey: "usPerfil",
      order: "usPerfil",
      size: midCol,
    },
    {
      labelHeader: "Concesionario",
      objectKey: "usConcesionario",
      order: "usConcesionario",
      size: largeCol,
    },
    {
      labelHeader: "Activo",
      objectKey: "usActivo",
      order: "usActivo",
      size: smallCol,
    },
    {
      labelHeader: "Bloqueado",
      objectKey: "usBloqueado",
      order: "usBloqueado",
      size: smallCol,
    },
    {
      labelHeader: "Región concesionario",
      objectKey: "coRegion",
      order: "coRegion",
      size: largeCol,
    },
  ],

  maintenanceHistoricoBastidor: [
    {
      labelHeader: "Bastidor",
      objectKey: "hbBastidor",
      order: "hbBastidor",
      size: largeCol,
    },
    {
      labelHeader: "Fecha alta",
      objectKey: "hbFechaalta",
      order: "hbFechaalta",
      size: smallCol,
    },
    {
      labelHeader: "Imagen Placa",
      objectKey: "hbCodimag",
      order: "hbCodimag",
      size: smallCol,
    },
    {
      labelHeader: "Tipo",
      objectKey: "hbTipo",
      order: "hbTipo",
      size: smallCol,
    },
    {
      labelHeader: "Variante",
      objectKey: "hbVariante",
      order: "hbVariante",
      size: midCol,
    },
    {
      labelHeader: "Versión",
      objectKey: "hbVersion",
      order: "hbVersion",
      size: largeCol,
    },
    {
      labelHeader: "Contraseña",
      objectKey: "hbContrasena",
      order: "hbContrasena",
      size: largeCol,
    },
    {
      labelHeader: "Emisiones",
      objectKey: "hbEmisionCo2",
      order: "hbEmisionCo2",
      size: midCol,
    },
  ],

  patronWltp: [
    {
      labelHeader: "Tipo",
      objectKey: "pwTipoHomol",
      order: "pwTipoHomol",
      size: largeCol,
    },
    {
      labelHeader: "Motor",
      objectKey: "pwMotor",
      order: "pwMotor",
      size: largeCol,
    },
    {
      labelHeader: "Cambio",
      objectKey: "pwTipoCambio",
      order: "pwTipoCambio",
      size: largeCol,
    },
    {
      labelHeader: "Correlativo",
      objectKey: "pwCorrelativo",
      order: "pwCorrelativo",
      size: largeCol,
    },
  ],

  ayudasGenerales: [
    {
      labelHeader: "Titulo",
      objectKey: "ayTitulo",
      order: "ayTitulo",
      size: extraLargeCol,
    },
    {
      labelHeader: "Fichero",
      objectKey: "ayFichero",
      order: "ayFichero",
      download: true,
      special: true,
      size: smallCol,
    },
  ],

  templates: [
    {
      labelHeader: "Identificador",
      objectKey: "paId",
      order: "paId",
      size: largeCol,
    },
    {
      labelHeader: "Descripción",
      objectKey: "paDescr",
      order: "paDescr",
      size: midCol,
    },
  ],

  printsFormats: [
    {
      labelHeader: "Formato",
      objectKey: "fiId",
      order: "fiId",
      size: midCol,
    },
    {
      labelHeader: "Descripción",
      objectKey: "fiDesc",
      order: "fiDesc",
      size: extraLargeCol,
    },
  ],

  fieldsOfFormats: [
    {
      labelHeader: "Campo",
      objectKey: "cfDescCampo",
      order: "cfDescCampo",
      size: largeCol,
    },
    {
      labelHeader: "Longitud máxima",
      objectKey: "cfLongMax",
      order: "cfLongMax",
      size: largeCol,
    },
    {
      labelHeader: "Tag XML",
      objectKey: "cfTagXml",
      order: "cfTagXml",
      size: largeCol,
    },
    {
      labelHeader: "Obligatorio",
      objectKey: "cfObligatorio",
      order: "cfObligatorio",
      size: largeCol,
    },
  ],

  rulesTemplates: [
    {
      labelHeader: "Correlativo",
      objectKey: "reIndice",
      order: "reIndice",
      size: largeCol,
    },
    {
      labelHeader: "Ecuación",
      objectKey: "reEcuacion",
      order: "reEcuacion",
      size: largeCol,
    },
    {
      labelHeader: "Descripción",
      objectKey: "reDesc",
      order: "reDesc",
      size: largeCol,
    },
    {
      labelHeader: "Plantilla",
      objectKey: "rePlantilla",
      order: "rePlantilla",
      size: largeCol,
    },
    {
      labelHeader: "",
      objectKey: "",
      order: "",
      size: "xsColButton ",
    },
  ],

  reforms: [
    {
      labelHeader: "Identificador",
      objectKey: "reId",
      order: "re_Id",
    },
    {
      labelHeader: "Descripción",
      objectKey: "reDescr",
      order: "re_descr",
    },
  ],

  printsRules: [
    {
      labelHeader: "Indice",
      objectKey: "riIndice",
      order: "riIndice",
      size: smallCol,
    },
    {
      labelHeader: "Tipo Placa",
      objectKey: "riTipoEtiqueta",
      order: "riTipoEtiqueta",
      size: midCol,
    },
    {
      labelHeader: "Tipo Etiqueta",
      objectKey: "tpNombre",
      order: "tpNombre",
      size: midCol,
    },
    {
      labelHeader: "Marca",
      objectKey: "riMarca",
      order: "riMarca",
      size: smallCol,
    },
    {
      labelHeader: "Tipo Homol.",
      objectKey: "riTipoHomologado",
      order: "riTipoHomologado",
      size: largeCol,
    },
    {
      labelHeader: "Formato Imp.",
      objectKey: "fiDesc",
      order: "fiDesc",
      size: largeCol,
    },
  ],

  dataCDT: [
    {
      labelHeader: "Tipo",
      objectKey: "daTipo",
      order: "daTipo",
      size: largeCol,
    },
    {
      labelHeader: "Variante",
      objectKey: "daVariante",
      order: "daVariante",
      size: largeCol,
    },
    {
      labelHeader: "Versión",
      objectKey: "daVersion",
      order: "daVersion",
      size: largeCol,
    },
    {
      labelHeader: "Contraseña",
      objectKey: "daContrasenya",
      order: "daContrasenya",
      size: largeCol,
    },
  ],

  royalDecree: [
    {
      labelHeader: "Identificador",
      objectKey: "cdId",
      order: "cdId",
      size: smallCol,
    },
    {
      labelHeader: "Texto",
      objectKey: "cdTexto",
      order: "cdTexto",
      size: extraLargeCol,
    },
    {
      labelHeader: "Tipo",
      objectKey: "cdTipo",
      order: "cdTipo",
      size: xsCol,
    },
    {
      labelHeader: "Longitud máxima",
      objectKey: "cdLongitud",
      order: "cdLongitud",
      size: xsCol,
    },
  ],

  certificatesMailBox: [
    {
      labelHeader: "Número de solicitud",
      objectKey: "id",
      order: "peId",
      size: midCol,
    },
    {
      labelHeader: "Bastidor",
      objectKey: "bastidor",
      order: "peBastidor",
      size: largeCol,
    },
    {
      labelHeader: "Matrícula",
      objectKey: "matricula",
      order: "peMatricula",
      size: smallCol,
    },
    {
      labelHeader: "Certificado",
      objectKey: "tipoCertificado",
      order: "tcertificado",
      size: smallCol,
    },
    {
      labelHeader: "Fec. solicitud",
      objectKey: "fechaCreacion",
      order: "peCreacion",
      size: midCol,
    },
    {
      labelHeader: "Analista",
      objectKey: "analista",
      order: "usuario2",
      size: smallCol,
    },
    {
      labelHeader: "Estado",
      objectKey: "estado",
      order: "estado",
      size: "xsCol ",
    },
    {
      labelHeader: "Nota",
      objectKey: "comentarios",
      order: "",
      hideOrderButton: true,
      note: true,
      special: true,
      style: columnaNotaStyle,
    },
    propertyEmpty,
  ],

  cocMailBox: [
    {
      labelHeader: "Número de solicitud",
      objectKey: "id",
      order: "peId",
      size: midCol,
    },
    {
      labelHeader: "Bastidor",
      objectKey: "bastidor",
      order: "peBastidor",
      size: largeCol,
    },
    {
      labelHeader: "Tipo solicitud",
      objectKey: "tipoSolicitud",
      order: "tcertificadoPlacaCOC",
      size: smallCol,
    },
    {
      labelHeader: "Fec. solicitud",
      objectKey: "fechaCreacion",
      order: "peCreacion",
      size: smallCol,
    },
    {
      labelHeader: "Analista",
      objectKey: "analista",
      order: "usuario2",
      size: smallCol,
    },
    {
      labelHeader: "Estado",
      objectKey: "estado",
      order: "estado",
      size: "xsCol ",
    },
    {
      labelHeader: "Nota",
      objectKey: "comentarios",
      order: "peComentarios",
      hideOrderButton: true,
      note: true,
      special: true,
      style: columnaNotaStyle,
    },
    propertyEmpty,
  ],

  placaMailBox: [
    {
      labelHeader: "Número de solicitud",
      objectKey: "id",
      order: "peId",
      size: midCol,
    },
    {
      labelHeader: "Bastidor",
      objectKey: "bastidor",
      order: "peBastidor",
      size: largeCol,
    },
    {
      labelHeader: "Importador",
      objectKey: "importador",
      order: "dpValor",
      size: smallCol,
    },
    {
      labelHeader: "Tipo solicitud",
      objectKey: "tipoSolicitud",
      order: "tcertificadoPlacaCOC",
      size: smallCol,
    },
    {
      labelHeader: "Fec. solicitud",
      objectKey: "fechaCreacion",
      order: "peCreacion",
      size: smallCol,
    },
    {
      labelHeader: "Analista",
      objectKey: "analista",
      order: "usuario2",
      size: "xsCol ",
    },
    {
      labelHeader: "Estado",
      objectKey: "estado",
      order: "estado",
      size: "xsCol ",
    },
    {
      labelHeader: "Nota",
      objectKey: "comentarios",
      order: "peComentarios",
      hideOrderButton: true,
      note: true,
      special: true,
      style: columnaNotaStyle,
    },
    propertyEmpty,
  ],

  certificatesQuery: [
    {
      labelHeader: "Número de solicitud",
      objectKey: "id",
      order: "peId",
      size: midCol,
    },
    {
      labelHeader: "Bastidor",
      objectKey: "bastidor",
      order: "peBastidor",
      size: largeCol,
    },
    {
      labelHeader: "Matrícula",
      objectKey: "matricula",
      order: "peMatricula",
      size: smallCol,
    },
    {
      labelHeader: "Certificado",
      objectKey: "tipoCertificado",
      order: "tcertificado",
      size: smallCol,
    },
    {
      labelHeader: "Fec. solicitud",
      objectKey: "fechaCreacion",
      order: "peCreacion",
      size: smallCol,
    },
    {
      labelHeader: "Fec. tramitación",
      objectKey: "fechaRealizacion",
      order: "peEntrega",
      size: smallCol,
    },
    {
      labelHeader: "Analista",
      objectKey: "analista",
      order: "usuario2",
      size: smallCol,
    },
    {
      labelHeader: "Estado",
      objectKey: "estado",
      order: "estado",
      size: "xsCol",
    },
    {
      labelHeader: "Nota",
      objectKey: "comentarios",
      order: "peComentarios",
      hideOrderButton: true,
      note: true,
      special: true,
      style: columnaNotaStyle,
    },
  ],

  certificatesQueryHistory: [
    {
      labelHeader: "Número de solicitud",
      objectKey: "id",
      order: "peId",
      size: midCol,
    },
    {
      labelHeader: "Bastidor",
      objectKey: "bastidor",
      order: "peBastidor",
      size: largeCol,
    },
    {
      labelHeader: "Matrícula",
      objectKey: "matricula",
      order: "peMatricula",
      size: smallCol,
    },
    {
      labelHeader: "Certificado",
      objectKey: "tipoCertificado",
      order: "tcertificado",
      size: smallCol,
    },
    {
      labelHeader: "Fec. solicitud",
      objectKey: "fechaCreacion",
      order: "peCreacion",
      size: smallCol,
    },
    {
      labelHeader: "Fec. tramitación",
      objectKey: "fechaRealizacion",
      order: "peEntrega",
      size: smallCol,
    },
    {
      labelHeader: "Analista",
      objectKey: "analista",
      order: "usuario2",
      size: smallCol,
    },
    {
      labelHeader: "Estado",
      objectKey: "estado",
      order: "estado",
      size: "xsCol",
    },
    {
      labelHeader: "Nota",
      objectKey: "comentarios",
      order: "peComentarios",
      hideOrderButton: true,
      note: true,
      special: true,
      size: "xsColButton",
    },
    {
      labelHeader: "Firma",
      objectKey: "codigoPegasusFirma",
      order: "peCodigopegasus",
      hideOrderButton: true,
      note: true,
      special: true,
      size: "xsColButton",
    },
    {
      labelHeader: "Archivo",
      objectKey: "codigoPegasus",
      order: "peCodigopegasus",
      hideOrderButton: true,
      file: true,
      special: true,
      size: "xsColButton",
    },
  ],

  placaQuery: [
    {
      labelHeader: "Número de solicitud",
      objectKey: "id",
      order: "peId",
      size: largeCol,
    },
    {
      labelHeader: "Bastidor",
      objectKey: "bastidor",
      order: "peBastidor",
      size: largeCol,
    },
    {
      labelHeader: "Importador",
      objectKey: "importador",
      order: "dpValor",
      size: midCol,
    },
    {
      labelHeader: "Tipo solicitud",
      objectKey: "tipoSolicitud",
      order: "tcertificadoPlacaCOC",
      size: midCol,
    },
    {
      labelHeader: "Fec. solicitud",
      objectKey: "fechaCreacion",
      order: "peCreacion",
      size: midCol,
    },
    {
      labelHeader: "Fec. tramitación",
      objectKey: "fechaRealizacion",
      order: "peEntrega",
      size: midCol,
    },
    {
      labelHeader: "Analista",
      objectKey: "analista",
      order: "usuario2",
      size: smallCol,
    },
    {
      labelHeader: "Estado",
      objectKey: "estado",
      order: "estado",
      size: smallCol,
    },
    {
      labelHeader: "Nota",
      objectKey: "comentarios",
      order: "peComentarios",
      hideOrderButton: true,
      note: true,
      special: true,
      style: columnaNotaStyle,
    },
  ],

  placaQueryFiles: [
    {
      labelHeader: "Fecha",
      objectKey: "reFecha",
      order: "reFecha",
      size: largeCol,
    },
    {
      labelHeader: "Analista",
      objectKey: "reAnalista",
      order: "reAnalista",
      size: largeCol,
    },
    {
      labelHeader: "Impresión",
      objectKey: "reTaller",
      order: "reTaller",
      size: largeCol,
    },
    {
      labelHeader: "Fichero",
      objectKey: "",
      order: "",
      hideOrderButton: true,
      download: true,
      special: true,
      size: largeCol,
    },
  ],

  cocQuery: [
    {
      labelHeader: "Número de solicitud",
      objectKey: "id",
      order: "peId",
      size: largeCol,
    },
    {
      labelHeader: "Bastidor",
      objectKey: "peBastidor",
      order: "peBastidor",
      size: largeCol,
    },
    {
      labelHeader: "Tipo solicitud",
      objectKey: "tcSolicitud",
      order: "tcertificadoPlacaCOC",
      size: midCol,
    },
    {
      labelHeader: "Fec. solicitud",
      objectKey: "peCreacion",
      order: "peCreacion",
      size: midCol,
    },
    {
      labelHeader: "Fec. tramitación",
      objectKey: "fechaRealizacion",
      order: "peEntrega",
      size: midCol,
    },
    {
      labelHeader: "Analista",
      objectKey: "analista",
      order: "usuario2",
      size: smallCol,
    },
    {
      labelHeader: "Estado",
      objectKey: "esId",
      order: "estado",
      size: "xsCol",
    },
    {
      labelHeader: "Nota",
      objectKey: "comentarios",
      order: "peComentarios",
      hideOrderButton: true,
      note: true,
      special: true,
      style: columnaNotaStyle,
    },
  ],

  previousCertsQuery: [
    {
      labelHeader: "Versión",
      objectKey: "hcRelease",
      order: "hcRelease",
      size: "xsCol",
    },
    {
      labelHeader: "CVE",
      objectKey: "hcCve",
      order: "hcCve",
      size: "xsCol",
    },
    {
      labelHeader: "Estado",
      objectKey: "hcEstado",
      order: "hcEstado",
      size: midCol,
    },
    {
      labelHeader: "Fecha firma",
      objectKey: "hcFecha",
      order: "hcFecha",
      size: midCol,
    },
    {
      labelHeader: "Documento",
      objectKey: "",
      order: "",
      download: true,
      special: true,
      size: "midSCol",
    },
  ],
  fsPlaca: [
    {
      labelHeader: "MY",
      objectKey: "fsPlacmye",
      order: "fs_placmye",
      size: smallCol,
    },
    {
      labelHeader: "MOD",
      objectKey: "fsPlacmod",
      order: "fs_placmod",
      size: smallCol,
    },
    {
      labelHeader: "PLACA",
      objectKey: "fsPlacimg",
      order: "fs_placimg",
      size: smallCol,
    },
    {
      labelHeader: "Combinacion PR'S",
      objectKey: "fsPlacprs",
      order: "",
      hideOrderButton: true,
      style: {
        "min-width": "550px",
        "max-width": "550px",
        width: "550px",
      },
    },
    {
      labelHeader: "S.INIC",
      objectKey: "fsSeminic",
      order: "fs_seminic",
      size: smallCol,
    },
    {
      labelHeader: "S.FIN",
      objectKey: "fsSemfina",
      order: "fs_semfina",
      size: smallCol,
    },
  ],
};
